import WalletIcon from '@mui/icons-material/Wallet';

// Our Routes
import { CLIENT_SORAWALLET_ROUTE } from 'routes';

const CLIENT_NAV_OPTIONS = [
	{
		icon: <WalletIcon />,
		title: 'Wallet',
		route: CLIENT_SORAWALLET_ROUTE
	}
];

export default CLIENT_NAV_OPTIONS;
